import { createDynamicThunk } from ".";

/**
 * LIST Sections
 */
export const fetchSectionsThunk = createDynamicThunk({
  typePrefix: "sections/fetchSectionsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Section
 */
export const submitSectionThunk = createDynamicThunk({
  typePrefix: "sections/submitSectionThunk",
  endpoint: "/sections",
  method: "POST",
});

/**
 * Fetch Permissions
 */
export const fetchPermissionsAsDropdownThunk = createDynamicThunk({
  typePrefix: "permissions/fetchPermissionsAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Additional Permissions
 */
export const fetchAdditionalPermissionsAsDropdownThunk = createDynamicThunk({
  typePrefix: "permissions/fetchAdditionalPermissionsAsDropdownThunk",
  endpoint: "/permissions/fetchAdditionalPermissions",
  method: "GET",
});
